// src/components/form/interval.jsx
import { forwardRef, useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import { Box, HStack, Text } from "@chakra-ui/react"
import "react-datepicker/dist/react-datepicker.css"

export default function Interval({ initial, label, onSelect = () => {}, onChange: onChangeCallback = () => {}, ...props }) {
    const [period, setPeriod] = useState(initial ?? [new Date(), new Date()])

    useEffect(() => {
        onChangeCallback(period)
        if (!!period?.[1]) onSelect(period)
    }, [period])

    const Input = forwardRef(({ value, onClick }, ref) => (
        <Box
            ref={ref}
            onClick={onClick}
            cursor="pointer"
            mx={2}
            py={2}
            px={4}
            bgColor="rgba(0,0,0,0)"
            borderRadius="md"
            width="180px"
            border="1px solid"
            borderColor="rgba(255, 255, 255, 0.16)"
            minHeight="40px"
            display="flex"
            alignItems="center"
        >
            <Text fontSize="xs" fontWeight="bold">
                {value && value.trim() ? value : "Selecione o intervalo"}
            </Text>
        </Box>
    ))

    return (
        <HStack spacing={2}>
            {label && <Text fontSize="sm" color="GrayText">{label}</Text>}
            <DatePicker
                selected={period?.[0]}
                startDate={period?.[0]}
                endDate={period?.[1]}
                onChange={setPeriod}
                selectsRange
                isClearable
                withPortal
                dateFormat="dd/MM/yyyy"
                customInput={<Input />}
                {...props}
            />
        </HStack>
    )
}
